import CityPageTemplate from "../city-template/CityPageTemplate";
import { cuyahogaFallsConfig } from "./data";

export default function CuyahogaFallsPage() {
  return <CityPageTemplate config={cuyahogaFallsConfig} />;
}